interface TypeBadgeProps {
  type: 'mcp' | 'skill' | 'plugin';
}

const TYPE_CLASSES: Record<string, string> = {
  mcp: 'bg-blue-600 text-blue-100',
  skill: 'bg-green-600 text-green-100',
  plugin: 'bg-orange-500 text-orange-100',
};

export function TypeBadge({ type }: TypeBadgeProps) {
  const classes = TYPE_CLASSES[type] ?? 'bg-gray-600 text-gray-100';
  return (
    <span
      className={`inline-block rounded-full px-2 py-0.5 text-xs font-semibold uppercase tracking-wide ${classes}`}
      data-type={type}
    >
      {type}
    </span>
  );
}
